import {
  View,
  Text,
  StyleSheet,
  FlatList,
  TouchableOpacity,
  Image,
} from "react-native";
import React, { useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { SearchScreentNavigationHeader } from "../WebScreens/Common/MobileDeviceNavigationHeader";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { genres } from "../../../Api/configs";

const SearchMobileScreen = () => {
  const [arrPopularGeners, arrSetPopularGeners] = useState(genres);

  const [arrGames, setArrGames] = useState([
    {
      id: 1,
      title: "Fifa",
      isSelected: 0,
    },
    {
      id: 2,
      title: "Call of Duty",
      isSelected: 0,
    },
    {
      id: 3,
      title: "MMA",
      isSelected: 0,
    },
    {
      id: 4,
      title: "Pub G",
      isSelected: 0,
    },
    {
      id: 5,
      title: "League of Legends",
      isSelected: 0,
    },
    {
      id: 6,
      title: "Indie",
      isSelected: 0,
    },
    {
      id: 7,
      title: "Taken",
      isSelected: 0,
    },
    {
      id: 8,
      title: "Fortnite",
      isSelected: 0,
    },
    {
      id: 9,
      title: "Chess",
      isSelected: 0,
    },
  ]);

  return (
    <View style={style.container}>
      <SearchScreentNavigationHeader btnSearchTapped={() => {}} />
      <View
        style={{
          paddingHorizontal: 15,
        }}
      >
        {/* Separater */}
        <View style={style.separaterStyle} />

        {/* Game Genre  */}
        <View
          style={{
            paddingVertical: 12,
            width: "100%",
            gap: 15,
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              {
                color: AppColors.white,
              },
            ]}
          >
            Game Genre
          </Text>

          <FlatList
            endFillColor="#000"
            overScrollMode="never"
            showsHorizontalScrollIndicator={false}
            horizontal={true}
            data={arrPopularGeners}
            renderItem={({ item, index }) => (
              <GamerItemView item={item} index={index} onPress={() => {}} />
            )}
            ItemSeparatorComponent={() => {
              return <View style={{ width: 20 }} />;
            }}
          />
        </View>

        {/* Separater */}
        <View style={style.separaterStyle} />

        {/* Games  */}
        <View
          style={{
            paddingVertical: 12,
            width: "100%",
            gap: 15,
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              {
                color: AppColors.white,
              },
            ]}
          >
            Games
          </Text>

          <FlatList
            endFillColor="#000"
            overScrollMode="never"
            showsHorizontalScrollIndicator={false}
            horizontal={true}
            data={arrGames}
            renderItem={({ item, index }) => (
              <GamerItemView item={item} index={index} onPress={() => {}} />
            )}
            ItemSeparatorComponent={() => {
              return <View style={{ width: 20 }} />;
            }}
          />
        </View>

        {/* Separater */}
        <View style={style.separaterStyle} />
        <View
          style={{
            paddingVertical: 12,
            gap: 25,
          }}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_14,
              {
                color: AppColors.white,
              },
            ]}
          >
            Participating
          </Text>

          <FlatList
            horizontal={true}
            data={[1, 1, 1, 1, 1]}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item, index }) => (
              <TouchableOpacity
                style={style.listBgViewStyle}
                onPress={() => {
                  // navigateToScreen(navigation, AppScreens.TicketDetailWebScreen)
                  // navigation.dispatch(
                  //     StackActions.push(
                  //         AppScreens.TicketDetailWebScreen,
                  //         {
                  //             eventID: item.eventID,
                  //         }
                  //     )
                  // );
                }}
              >
                {/* User Details */}
                <View
                  style={{
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      { color: AppColors.white },
                    ]}
                  >
                    Apex Legends
                  </Text>
                </View>
                {/* Streaming View */}
                <View
                  style={{
                    height: 140,
                    backgroundColor: AppColors.appGrayColor_1C1C1C,
                    borderRadius: 10,
                    justifyContent: "flex-start",
                    paddingLeft: 8,
                    paddingTop: 8,
                  }}
                >
                  <View style={style.attendeesBgViewStyle}>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.white,
                          paddingHorizontal: 9,
                          paddingVertical: 3,
                        },
                      ]}
                    >
                      1.2k Attendees
                    </Text>
                  </View>
                </View>

                {/* Profress View */}
                <View
                  style={{
                    height: 12,
                    backgroundColor: AppColors.appBlackColor_1e1e1e,
                    borderRadius: 12,
                  }}
                >
                  <View
                    style={{
                      height: 12,
                      backgroundColor: AppColors.appGreenColor_51AF07,
                      borderRadius: 12,
                      width: "75%",
                    }}
                  />
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                    flexWrap: "wrap",
                    gap: 8,
                  }}
                >
                  <View
                    style={{
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                      paddingHorizontal: 10,
                      paddingVertical: 6,
                      borderRadius: 4,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.white,
                          backgroundColor: AppColors.appViolentColor_6D08C3,
                        },
                      ]}
                    >
                      Tomorrow 1PM
                    </Text>
                  </View>

                  <View
                    style={{
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                      paddingHorizontal: 10,
                      paddingVertical: 6,
                      borderRadius: 4,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.white,
                          backgroundColor: AppColors.appViolentColor_6D08C3,
                        },
                      ]}
                    >
                      Fortnite
                    </Text>
                  </View>

                  <View
                    style={{
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                      paddingHorizontal: 10,
                      paddingVertical: 6,
                      borderRadius: 4,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.white,
                          backgroundColor: AppColors.appViolentColor_6D08C3,
                        },
                      ]}
                    >
                      £2-10
                    </Text>
                  </View>
                </View>

                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <TouchableOpacity onPress={() => {}}>
                    <Image
                      source={AppImages.icShareCircle}
                      style={{ height: 35, width: 35, resizeMode: "contain" }}
                    />
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={{
                      backgroundColor: AppColors.appGreenColor_51AF07,
                      borderRadius: 35,
                      justifyContent: "center",
                      alignItems: "center",
                      paddingHorizontal: 17,
                      // marginHorizontal: 10,
                    }}
                    onPress={() => {}}
                  >
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_16,
                        {
                          color: AppColors.white,
                        },
                      ]}
                    >
                      Sign-Up
                    </Text>
                  </TouchableOpacity>
                </View>
              </TouchableOpacity>
            )}
            ItemSeparatorComponent={() => {
              return <View style={{ width: 20 }} />;
            }}
          />
        </View>
      </View>
    </View>
  );

  function GamerItemView(props) {
    const { item, index, onPress } = props;
    return (
      <TouchableOpacity
        style={{
          backgroundColor: AppColors.appViolentColor_6D08C3,
          borderRadius: 10,
        }}
        onPress={() => {
          onPress();
        }}
      >
        <Text
          style={[
            AppFontStyle.BOLD_ANYBODY_12,
            {
              paddingVertical: 12,
              paddingHorizontal: 18,
              color: AppColors.white,
            },
          ]}
        >
          {item.title}
        </Text>
      </TouchableOpacity>
    );
  }
};

export default SearchMobileScreen;

const style = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: AppColors.black_121212,
  },
  separaterStyle: {
    height: 2,
    backgroundColor: AppColors.appGrayColor_1C1C1C,
    width: "96%",
  },
  listBgViewStyle: {
    gap: 8,
    marginBottom: 18,
  },
  attendeesBgViewStyle: {
    backgroundColor: AppColors.appViolentColor_6D08C3,
    borderRadius: 7,
    alignSelf: "flex-start",
  },
});
